import request from '@/utils/request'

export function getWorkforceForecastOverview () {
  return request({
    url: '/addon/workforceForecast/overview',
    method: 'get'
  })
}
